import { PrescriptionPrintHistoryClient } from "@/Common/Api/Patient/PrescriptionPrintHistoryClient";
import { IPharmacyInfo } from "@/Common/Api/Pharmacy/Dto/Responses/IPharmacyInfo";
import { LoginPinFrequencyModel } from "@/Common/Models/Employee/LoginFrequencyModel";
import { Guid } from "@/Common/Models/Guid";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { ExportableFileDispatcher } from "@/ExportableFile/Helpers/ExportableFileDispatcher";
import { ExportableFileHelper } from "@/ExportableFile/Helpers/ExportableFileHelper";
import { ExportMode } from "@/ExportableFile/Models/enum/ExportMode";
import { FileTypePrescription } from "@/ExportableFile/Models/FileTypes/FileTypePrescription";
import { PatientPrescriptionItem } from "@/Patient/Models/Medication/PatientPrescriptionItem";
import { PrescriptionPrintHistory } from "@/Patient/Models/Medication/PrescriptionPrintHistory";

interface OpenSignFaxPrintPopupParams {
    patientContactId: Guid;
    prescription: PatientPrescriptionItem;
    exportMode: ExportMode;
    preferredPharmacy: IPharmacyInfo;
    onSignButtonCallback?: () => void;
}

export class PrescriptionExportableFileDispatcher {
    public static openSignFaxPrintPopupForPrescription(params: OpenSignFaxPrintPopupParams): void {
        const exportableFile = new FileTypePrescription({
            prescriptionId: params.prescription.PrescriptionId,
            description: cacheStore.GetString("PrescriptionLabel"),
            date: LuxonDateTimeParser.parse(params.prescription.PrescriptionDate)?.toString() ?? "",
            supervisorContactId: IsNullOrWhiteSpace(sessionStore.lockedSupervisorContactId) ? null : sessionStore.lockedSupervisorContactId
        });

        if (cacheStore.validateMylePharmacy(!!params.preferredPharmacy?.IsMylePharmacy)) {
            exportableFile.applyPrepositionedPharmacyInfoOverlay(params.preferredPharmacy);
        }

        const pinFrequencyModel = LoginPinFrequencyModel.fromResponseModel(sessionStore.getCurrentEmployee()?.Model?.LoginPinFrequency);
        const pinFrequencyToken = cacheStore.ClinicSettings.EnableQuickDocumentSigning
            ? (ExportableFileHelper.getPinFrequencyTokenByFileType(exportableFile.fileType, pinFrequencyModel) ?? "")
            : "";

        const config = ExportableFileDispatcher.buildConfig(
            {
                ...params,
                defaultContext: params.preferredPharmacy,
                exportableFile,
                signedPrintAuthorizations: params.prescription.SignedPrintAuthorizations,
                isSignable: sessionStore.canSignPrescription(params.prescription.PrecribedByEmployeeId),
                pinFrequencyToken: pinFrequencyToken,
                sentFaxItemId: params.prescription.PrescriptionId,
                onPrintButtonCallback: async () => {
                    if (cacheStore.ClinicSettings.EnableMedicationsPrintFilterAndHistory) {
                        const addPrescriptionPrintHistoryResponse = await PrescriptionPrintHistoryClient.addPrescriptionPrintHistory(params.prescription.PrescriptionId);
                        const prescriptionPrintHistory = new PrescriptionPrintHistory(addPrescriptionPrintHistoryResponse.data);

                        patientStore.addPrescriptionPrintHistory(prescriptionPrintHistory, patientStore.getCurrentPatientContactId());
                    }
                }
            }
        );

        ExportableFileDispatcher.dispatch(config);
    }
}
